import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const Title = styled("span")(() => ({
  fontSize: 18,
  fontWeight: 700,
  fontFamily: "Manrope",
}));

export const Subtitle = styled("span")(() => ({
  fontSize: 18,
  fontWeight: 700,
  fontFamily: "Manrope",
  color: "#667085",
}));

export const ContainerMaterialIcon = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

const styles = makeStyles(() => ({
  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  button: {
    cursor: "pointer",
  },
  formControl: {
    width: "110px",
  },
  input: {
    "& input": {
      textAlign: "center",
      padding: "0 10px",
    },
  },
  container: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px",
  },
  containerView: {
    position: "relative",
    paddingBottom: "20px",
  },
  inputQuantity: {
    maxWidth: "110px",
    display: "flex",
    flexDirection: "row",
  },
  inputPrice: {
    maxWidth: "124px",
    display: "flex",
    flexDirection: "row",
  },
  scrollHidden: {
    "& div[data-cy='table-container']": {
      overflow: "hidden",
    },
  },
  scrollHiddenView: {
    "& div[data-cy='table-container']": {
      overflow: "hidden",
    },
    "& .tableContainerX": {
      borderRadius: "8px 8px 0px 0px",
    },
  },
  viewStyle: {
    borderWidth: "0px 1px 1px 1px",
    borderRadius: "0px 0px 8px 8px",
    borderStyle: "solid",
    borderColor: "#e4e6ec",
  },
  customColumnView: {
    padding: "12px !important",
  },
  totalWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#F9FAFB",
    borderRadius: "0 0 12px 12px",
    padding: "12px 5px",
    "& > span": {
      font: "700 16px/24px Manrope",
      color: "#308cdb",
    },
    "& p": {
      font: "700 16px/24px Manrope",
      color: "#465869",
    },
  },
  withBorder: {
    border: "1px solid #e4e7e6",
    borderRadius: 12,
    marginTop: 16,
    padding: 8,
  },
  actionButtonShow: {
    border: "1px solid #E4E7EC !important",
  },
  actionButtonShowBody: {
    display: "flex",
    flexDirection: "column",
    padding: "6px 6px 6px 16px",
  },
  headerTitleContainer: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: "10px",
    paddingTop: "8px",
  },
  ml12: {
    marginLeft: 12,
  },
  containerIconLink: {
    cursor: "help",
    alignItems: "flex-end",
    display: "flex",
  },
}));

export default styles;
